import { configs } from 'configs'

const GA4_SCRIPT_ID = 'ga4-gtag-script'
let isGa4Initialized = false

const getGA4MeasurementId = (): string | undefined => {
  return configs.ga4MeasurementId
}

const isGA4Enabled = (): boolean => {
  return Boolean(getGA4MeasurementId())
}

export const initializeGA4 = (): void => {
  if (!isGA4Enabled() || isGa4Initialized) {
    return
  }

  const measurementId = getGA4MeasurementId()
  if (!measurementId) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments as any)
  }

  if (!document.getElementById(GA4_SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = GA4_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    script.onerror = () => {
      if (process.env.NODE_ENV === 'development') {
        console.warn('GA4 script failed to load. Check adblock/network/CSP.')
      }
    }
    document.head.appendChild(script)
  }

  window.gtag('js', new Date())
  window.gtag('config', measurementId, {
    send_page_view: false,
    debug_mode: process.env.NODE_ENV !== 'production',
  })

  isGa4Initialized = true
}

type TrackGA4PageViewParams = {
  pagePath: string
  pageTitle?: string
}

export const trackGA4PageView = ({
  pagePath,
  pageTitle,
}: TrackGA4PageViewParams): void => {
  if (!isGA4Enabled()) {
    return
  }

  initializeGA4()

  window.gtag?.('event', 'page_view', {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: pageTitle,
    debug_mode: process.env.NODE_ENV !== 'production',
  })
}
